// @flow

import type { ManagementState } from "./types";

export const initialState: ManagementState = {
  incidentRegister: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  incidentRatesReport: {
    MONTH: {
      content: [],
      pagination: {
        sort: { orders: [] },
        pageNumber: 0,
        pageSize: 0,
        offset: 0,
      },
    },
    CAUSE: {
      content: [],
      pagination: {
        sort: { orders: [] },
        pageNumber: 0,
        pageSize: 0,
        offset: 0,
      },
    },
    headlines: {
      total: "",
      totalNi: "",
      clinicalIncidentPercent: "",
      mostCommonCause: "",
    },
  },
  incidentTypes: [],
  incidentCauses: [],
  callHandlers: [],
  activeCallbacks: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  advisorActivity: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  advisors: {
    current: null,
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  busiestClients: {
    content: [],
    pagination: {
      sort: {
        orders: [
          {
            direction: "DESC",
            property: "calls",
          },
        ],
      },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  callbackQueues: null,
  callScripts: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  completedCallbacks: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  dashboard: {
    headlines: {
      totalInboundInteractions: 0,
      totalCallbacks: 0,
      totalInteractions: 0,
      overflowInteractions: 0,
      asapCallbacks: 0,
      asapSlaPercentage: "0.00",
      scheduledCallbacks: 0,
      scheduledSlaPercentage: "n/a",
    },
    clientsSummary: [
      {
        clientId: 1,
        clientName: "",
        inboundInteractions: 0,
        asapCallbacks: 0,
        schedulledCallbacks: 0,
        autoCallbacks: 0,
        totalInteractions: 0,
        avgAsapTime: "",
        asapSlapPercentage: "",
        scheduledSlaPercentage: "",
        overflowInteractions: 0,
        calls: 0,
        callbacks: 0,
      },
    ],
    advisorsSummary: [
      {
        advisorId: 1,
        advisorName: "",
        inboundInteractions: 0,
        asapCallbacks: 0,
        scheduledCallbacks: 0,
        autoCallbacks: 0,
        totalInteractions: 138,
        totalLogins: 0,
        loginSuccessRate: "",
      },
    ],
  },
  employees: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  error: null,
  login: null,
  medicalTriageScripts: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  medicalTriageSymptoms: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  allergies: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  conditions: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  medications: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  medicationTypes: [],
  vaccinations: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  providers: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  serviceTypes: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  wellbeingCategories: [],
  parentAbsenceReasons: [],
  carePlanActivities: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  carePlanActivityTypes: [],
  carePlanActivityPeriods: [],
  carePlanActivityParents: [],
  carePlanActivityCounters: [],
  supportPlanActivities: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  supportPlanActivityCounters: [],
  supportPlanJobDutyConfigs: [],
  triageQuestions: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  triageQuestionSymptoms: [],
  triageAdvices: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  triageAdviceSymptoms: [],
  modals: {
    logNewIncident: {
      visible: false,
    },
    viewEditIncident: {
      isEditable: false,
      visible: false,
      data: null,
    },
    removeCallback: {
      visible: false,
    },
    rescheduleCallback: {
      visible: false,
    },
    createCallback: {
      visible: false,
    },
    add: {
      visible: false,
      user: null,
    },
    edit: {
      visible: false,
      user: null,
    },
    editCallScript: {
      visible: false,
      id: null,
      displayName: null,
      formData: {
        instructionText: null,
        scriptText: null,
      },
    },
    editLogin: {
      visible: false,
    },
    editMedicalTriageScript: {
      visible: false,
      id: null,
      displayName: null,
      formData: {
        scriptText: null,
      },
    },
    editMedicalTriageSymptom: {
      visible: false,
      id: null,
      name: null,
      formData: {
        guidanceNotes: null,
      },
    },
    editCallbackQueue: {
      visible: false,
      scheduledWindows: [],
    },
    releaseNote: {
      visible: false,
    },
    allergy: {
      visible: false,
      data: null,
    },
    condition: {
      visible: false,
      data: null,
    },
    medication: {
      visible: false,
      data: null,
    },
    vaccination: {
      visible: false,
      data: null,
    },
    provider: {
      visible: false,
      data: null,
      logoUrl: null,
    },
    serviceType: {
      visible: false,
      data: null,
    },
    carePlanActivity: {
      visible: false,
      data: null,
    },
    supportPlanActivity: {
      visible: false,
      data: null,
    },
    triageQuestion: {
      visible: false,
      data: null,
    },
    triageAdvice: {
      visible: false,
      data: null,
    },
  },
  releaseNote: null,
  requestsInProgress: 0,
  scheduledWindows: {
    content: [],
  },
  users: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
  },
  serviceDesk: {
    projects: [],
    ticketStatuses: [],
  },
  healthNotices: {
    current: null,
    list: {
      content: [],
      pagination: {
        sort: { orders: [] },
        pageNumber: 0,
        pageSize: 0,
        offset: 0,
      },
    },
  },
  images: {
    list: {
      content: [],
      pagination: {
        sort: { orders: [] },
        pageNumber: 0,
        pageSize: 0,
        offset: 0,
      },
    },
  },
};

export default initialState;
